
import { Component, Vue, Prop } from 'vue-property-decorator'
import { UserModule } from '../../store/modules/user'
import { CourseModule } from '../../store/modules/course'
import { getCookie, setCookie, mul, getMonth, formatDate } from '../../utils/publish'
import echarts from 'echarts'
  @Component({ 
    name: 'DashboardTeacherTime',
    components: {} 
  })
  
export default class DashboardTeacherTime extends Vue {
    tableHeight: number = window.innerHeight - 200
    tableWidth: number = window.innerWidth - 270
    list:any = []
    instrumentTypes:any = []
    teacherType:any = []
    campusType:any = []
    time:any = [new Date(<any>new Date() - 1000 * 60 * 60 * 24 * 30), new Date()]
    start_time = ''
    end_time = ''
    employee_id: any = ''
    ages: any = []
    source: any = []
    loading: boolean = false
    isLoading: boolean = true
    from: any = ''
    fromKey: any = ''
    fromValue: any = ''
    fromCampus: any = ''
    fromTime: any = ''
    fromTeacher: any = ''
    fromInstrument: any = ''
    fromSource: any = ''
    fromAges: any = ''
    teacherArr: any = []
    campusArr: any = []
    instrumentArr: any = []
    baseCourselist: any = []
    courseType: any = []
    courseTypeList:  any = [
      {
        name: '正式课',
        id: '1'
      },
      {
        name: '试听课',
        id: '2'
      },
      {
        name: '占用课',
        id: '3'
      }
    ]
    page: Number = 1
    size: Number = 10
    total_count: any = 0
    courseLevelList: any = []
    classLevelId: any = []
    getPeople: any = []
    getPeopleList: any = []
    selectBaseCourse: any = []
    campus_id: any = []
    tableData:any = []
    fromPage: any = ''
    is_work:Number = 0


    getHeight() {
      window.onresize = () =>{
        this.tableHeight = window.innerHeight - 200
      }
    }
    
    async teacher() { // 教师列表
      const res = await UserModule.getTeacher()
      this.teacherArr = res.data.list
    }

    async campus() { // 校区
      const res = await UserModule.getSchool()
      this.campusArr = res.data.list
    }

    async getInstrumentType() { // 乐器类型
      const res = await UserModule.InstrumentType()
      this.instrumentArr = res.data.list
    }

    async getCourseType() {  // 获取课程种类
      const res: any = await UserModule.courseType()
      if(res.code === 200) {
        this.baseCourselist = res.data.list
      }
    }

    async getCourseLevel() { // 获取课程等级
      const res: any = await UserModule.courseLevel({ org_id: '' })
      if (res.code === 200) {
        this.courseLevelList = res.data.list
      }
    }
    
    async peopleList() {  // 获取人员数据
      const res: any = await UserModule.getCampus({ types: 'list', org_id: '' })
      if (res.code === 200) {
        this.getPeopleList = res.data.list
      }
    }

    selectChange(val) {
      this.page = 1
      this.getTeachList()
    }
    selectCampusChange(val) {
      this.getCourseType()
      this.page = 1
      this.getTeachList()
    }

    changeTime(val) {
      const end = new Date(Date.parse(<any>new Date(val[1])) + 24 * 60 * 60 * 1000 - 1000)
      this.time = [val[0], end]
      if (this.time) {
        this.start_time = (Date.parse(<any>this.time[0]) / 1000).toString()
        this.end_time = (Date.parse(<any>this.time[1]) / 1000).toString()
      } else {
        this.start_time = ''
        this.end_time = ''
      }
      this.page = 1
      this.getTeachList()
    }

    handleCurrentChange(val) {
      this.page = val
      this.getTeachList()
    }

    async getTeachList() {
      const res = await UserModule.teachCourseList({ campus_id: this.campusType.toString(), teacher_id: this.teacherType.toString(), instrument_type: this.instrumentTypes.toString(), course_type_id: this.selectBaseCourse.toString(), course_type: this.courseType.toString(), course_level_id: this.classLevelId.toString(), sale_employee_id: this.getPeople.toString(), start_time: this.start_time, end_time: this.end_time, page: this.page, size: this.size, is_work: this.is_work})
      this.tableData = res.data.list
      this.total_count = res.data.total
      if (this.tableData.length > 0) {
        this.loading = true
      } else {
        this.loading = false
      }
      this.isLoading = false
    }

    getTime(time, type) {
      return formatDate(time, type)
    }

    async selectHistory() {
      const page_name: string = '4'
      const res: any = await CourseModule.selectHistory({page_name: page_name})
      if (this.from) {
        this.campusType = this.fromCampus
        if (this.fromKey === 'course_type_id') {
          this.selectBaseCourse = [this.fromValue]
        } else if (this.fromKey === 'course_type') { // 正式课
          this.courseType = ['1']
        } else if (this.fromKey === 'shiting') { // 试听课
          this.courseType = ['2']
        } else if (this.fromKey === 'zhanyong') { // 占用课
          this.courseType = ['3']
        } else if (this.fromKey === '') {
          if (this.fromPage === 'fbkcsc') {
            this.courseType = []
          }
        }
        this.teacherType = this.fromTeacher
        this.instrumentTypes = this.fromInstrument
        this.classLevelId = []
        this.getPeople = []
        this.time = this.fromTime
        this.start_time = (Date.parse(<any>this.time[0])/1000).toString()
        this.end_time = (Date.parse(<any>this.time[1])/1000).toString()
        this.is_work = 1
      } else {
        this.is_work = 0
        this.campusType = res.data.campus_id ? res.data.campus_id.split(',') : []
        this.teacherType = res.data.teacher_id ? res.data.teacher_id.split(',') : []
        this.instrumentTypes = res.data.instrument_type ? res.data.instrument_type.split(',') : []
        this.selectBaseCourse = res.data.course_type_id ? res.data.course_type_id.split(',') : []
        this.courseType = res.data.course_type ? res.data.course_type.split(',') : []
        this.classLevelId = res.data.course_level_id ? res.data.course_level_id.split(',') : []
        this.getPeople = res.data.sale_employee_id ? res.data.sale_employee_id.split(',') : []
        this.time = [new Date(res.data.start_time * 1000), new Date(res.data.end_time * 1000)]
      }
      this.getCourseType()
      this.getTeachList()
      this.teacher()
      this.campus()
      this.getInstrumentType()
      this.getCourseLevel()
      this.peopleList()
    }

    mounted() {
      this.from = this.$route.query.from
      this.fromKey = this.$route.query.key
      this.fromValue = this.$route.query.value
      this.fromPage = this.$route.query.fromPage
      this.fromCampus = this.$route.query.campus ? JSON.parse(<any>this.$route.query.campus) : []
      this.fromTime = this.$route.query.time ? JSON.parse(<any>this.$route.query.time) : []
      this.fromTeacher = this.$route.query.teacher ? JSON.parse(<any>this.$route.query.teacher) : []
      this.fromInstrument = this.$route.query.instrument ? JSON.parse(<any>this.$route.query.instrument) : []
      this.fromSource = this.$route.query.source ? JSON.parse(<any>this.$route.query.source) : []
      this.fromAges = this.$route.query.ages ? JSON.parse(<any>this.$route.query.ages) : []

      this.start_time = (Date.parse(<any>this.time[0])/1000).toString()
      this.end_time = (Date.parse(<any>this.time[1])/1000).toString()
      this.getHeight()
      this.selectHistory()
    }
  }
